module.exports = {
  __init__: ['spaceToolVisuals'],
  __depends__: [require(106), require(136), require(155) ],
  spaceTool: ['type', require(163)],
  spaceToolVisuals: ['type', require(164) ]
};
